import { Link as GatsbyLink } from 'gatsby-link'
import React from 'react'

import { usefulLinks } from './data'

const UsefulLinks = () => (
  <div className="flex flex-col gap-6">
    <h3 className="text-075 text-amplification-black-premium/70 group-[.is-dark-mode]/menu:text-white-50/70 uppercase">
      Liens utiles
    </h3>
    <ul className="flex flex-col gap-6">
      {usefulLinks.map(({ label, url }, index) => (
        <GatsbyLink
          key={`useful-link-${index}`}
          className="text-110 group-[.is-dark-mode]/menu:text-white-50 block h-full w-full text-[#232323] hover:opacity-60"
          to={url}
        >
          {label}
        </GatsbyLink>
      ))}
    </ul>
  </div>
)

export default UsefulLinks
